<template>
  <div class="background" v-bind:style="{'backgroundImage' : 'url(' + require('../assets/images/background2.jpg')}">
  </div>
</template>

<script>
export default {
  data () {
    return {
      piyo: "piyo"
    }
  }
}
</script>

<style>

div.background{
  content:"";
  display:block;
  position: fixed;
  top:0;
  left:0;
  z-index:-1;
  width: 100%;
  height:100vh;
  background-repeat  : no-repeat, repeat;
  background-position: right bottom;
  opacity: 0.0;
  background-size:cover;
}

</style>



// WEBPACK FOOTER //
// src/components/Background.vue